import React, { useEffect, useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";

import createRegCss from "../../css/createregister.module.css";
import commoncss from "../../css/common.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Loader2 from "../../elements/Loader2";
import Dropdown from "../../elements/Dropdown";
import { useHistory, useParams } from "react-router";
import { createLoanRegisterApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { ReactComponent as CalenderIcon } from "../../assets/icons/calender.svg";

const CreateFixedAssetsRegister = (props) => {
  let companyOptions = props.companyOptions;
  const history = useHistory();

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(null);
  const [company, setCompany] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const createRegister = () => {
    const payload = {
      name: regName,
      companyID: company.value,
      startDate: startDate?startDate.format("DD-MM-YYYY"):null,
      endDate: endDate?endDate.format("DD-MM-YYYY"):null,
    };
    // createLoanRegisterApiHandler(payload)
    //   .then((response) => {
    //     let resp = response?.data?.loan;
    //     if (resp?._id) {
    //       setLoader(true);
    //       history.push(`/myfinV2/loans/overview/${resp?._id}/${resp?.companyID}`)
    //     }
    //   })
    //   .catch((error) => {
    //     swal(
    //       "Error",
    //       error?.response?.data?.error || "Unable Create Fixed Assets Register",
    //       "error"
    //     );
    //   });
  };
  return (
    <>
      {loader && <Loader2 />}
      <div className={createRegCss.alignForm}>
        <div className={createRegCss.container2}>
          <div className={`${commoncss.dFlex} mb-3`}>
            <div
              className={commoncss.dFlexClm}
              style={{ alignItems: "center" }}
            >
              <span className={createRegCss.heading1}>
                Create Fixed Assets Register
              </span>
              <span className={createRegCss.label1}>
                Lorem ipsum dolor sit amet consec
              </span>
            </div>
          </div>
          <div className={`${createRegCss.container3} mt-3 mb-1`}>
            <InputGroup
              label="Name of Fixed Assets Register"
              inputs={[
                <>
                  <input
                    name="fareg_name"
                    placeholder="Fixed Assets register"
                    type="text"
                    value={regName}
                    onChange={(e) => setRegName(e.target.value)}
                  />
                </>,
              ]}
            />

            <InputGroup
              label="Company name"
              class_="mt-2"
              inputs={[
                <>
                  {companyOptions.length > 0 && (
                    <Dropdown
                      //   label="Select Company"
                      value={company}
                      options={companyOptions}
                      onSelect={(opt) => setCompany(opt)}
                      placeHolder={"Select Company"}
                    />
                  )}
                </>,
              ]}
            />
            <InputGroup
              inputs={[
                <>
                  <InputGroup
                    label="Start Date"
                    inputs={[
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["DatePicker", "MobileDatePicker"]}
                          >
                            <MobileDatePicker
                              className={`${commoncss.datePickerContainer} ${commoncss.clickable} `}
                              value={startDate ? dayjs(startDate) : null}
                              onChange={(value) => {
                                  setStartDate(value);
                              }}
                              format="DD-MMM-YYYY"
                              slotProps={{
                                textField: {
                                  InputProps: {
                                    disableUnderline: true,
                                  },
                                  inputProps: {
                                    placeholder: "DD-MMM-YYYY",
                                  },
                                  sx: {
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                          />
                        </span>
                      </>,
                    ]}
                  />
                </>,
                <>
                  <InputGroup
                    label="End Date"
                    inputs={[
                      <>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["DatePicker", "MobileDatePicker"]}
                          >
                            <MobileDatePicker
                              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                              value={endDate ? dayjs(endDate) : null}
                              onChange={(value) => {
                                  setEndDate(value);
                              }}
                              format="DD-MMM-YYYY"
                              slotProps={{
                                textField: {
                                  InputProps: {
                                    disableUnderline: true,
                                  },
                                  inputProps: {
                                    placeholder: "DD-MMM-YYYY",
                                  },
                                  sx: {
                                    "& fieldset": {
                                      border: "none",
                                    },
                                  },
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                          />
                        </span>
                      </>,
                    ]}
                  />
                </>,
              ]}
            />

            <div
              className="mt-4"
              style={{ width: "70%", placeSelf: "center" }}
              onClick={createRegister}
            >
              <button
                type="submit"
                className={buttoncss.primary}
                style={{
                  padding: "7px",
                  width: "100%",
                  "border-radius": "12px",
                }}
              >
                Create Fixed Assets Register
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateFixedAssetsRegister;
